import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=3b04cf1a&scoped=true&"
import script from "./InfoComponent.vue?vue&type=script&lang=js&"
export * from "./InfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoComponent.vue?vue&type=style&index=0&id=3b04cf1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04cf1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b04cf1a')) {
      api.createRecord('3b04cf1a', component.options)
    } else {
      api.reload('3b04cf1a', component.options)
    }
    module.hot.accept("./InfoComponent.vue?vue&type=template&id=3b04cf1a&scoped=true&", function () {
      api.rerender('3b04cf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/info/InfoComponent.vue"
export default component.exports